import { createSlice } from '@reduxjs/toolkit';

export interface MapsSliceStates {
    tagIds?: string[];
    latlng?: {lng: number, lat: number} | null;
    mapHeight?: number;
}

export const MapsSlice = createSlice({
    name: 'Maps',
    initialState: {
        tagIds: [],
        latlng: null,
        mapHeight: 0,
    },
    reducers: {
        setTagIds: (state, action) => {
            state.tagIds = action.payload;
        },
        setLatLng: (state, action) => {
            state.latlng = action.payload;
        },
        clearCluster: (state, action) => {
            state.tagIds = [];
            state.latlng = null;
        },
        setMapHeight: (state, action) => {
            state.mapHeight = action.payload;
        },
    },
});

export default MapsSlice
export const MapsActions = MapsSlice.actions
export const MapsSelector = (store: { maps: MapsSliceStates }): MapsSliceStates => store.maps;
import { createSlice } from '@reduxjs/toolkit';

export interface MapsSliceStates {
    tagIds?: string[];
    latlng?: {lng: number, lat: number} | null;
    mapHeight?: number;
}

export const MapsSlice = createSlice({
    name: 'Maps',
    initialState: {
        tagIds: [],
        latlng: null,
        mapHeight: 0,
    },
    reducers: {
        setTagIds: (state, action) => {
            state.tagIds = action.payload;
        },
        setLatLng: (state, action) => {
            state.latlng = action.payload;
        },
        clearCluster: (state, action) => {
            state.tagIds = [];
            state.latlng = null;
        },
        setMapHeight: (state, action) => {
            state.mapHeight = action.payload;
        },
    },
});

export default MapsSlice
export const MapsActions = MapsSlice.actions
export const MapsSelector = (store: { maps: MapsSliceStates }): MapsSliceStates => store.maps;
